import http from '../_http'

const agent = {
  //default
  listAgent: (m) => { return http.post(`manager/history/agent/list`, m); },
  detail: (m) => { return http.get(`manager/history/agent/${m.id}`); },

  //info
  infoAgent: (m) => { return http.post(`manager/history/agent`, m); },
}

export default agent

export { agent }